import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/project/index'
import Add from '@/project/add'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/login',
      name: 'index',
      component: Index
    },
    {
      path: '/add',
      name: 'add',
      component: Add
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js